export default __webpack_public_path__ + "static/media/Sky-Clearing Cut.9a7f5451.png";